<template>
  <div>
    <br/>
    <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="true"></b-loading>
    <div class="field">
      <b-input
        v-model="searchFilter"
        icon="magnify"
        placeholder="Search for challenges containing this text..."
        :value="txtFilter"
      >
      </b-input>
    </div>
    <b-table
      :data="questions"
      v-if="questions"
      :row-class="getRowClass"
      :default-sort="['name', 'asc']"
    >
      <template slot-scope="props">
        <b-table-column class="centered-table-content" field="name" label="Challenge name" sortable>{{props.row.name}}</b-table-column>
        <b-table-column class="centered-table-content" field="question" label="Question text" sortable>{{props.row.question | truncate(40) }}</b-table-column>
        <b-table-column class="centered-table-content" field="points" label="Points" sortable numeric>{{props.row.points}}</b-table-column>
        <b-table-column class="centered-table-content" field="difficulty" label="Difficulty" sortable numeric>{{props.row.difficulty}}</b-table-column>
        <b-table-column class="centered-table-content" label="Geolocked?">
          <b-tag :type="props.row.unlocked_forced ? 'is-danger' : 'is-success'">
            <span>{{ props.row.unlocked_forced ? 'No' : 'Yes' }}</span>
          </b-tag>
          </b-table-column>
        <b-table-column class="centered-table-content" field="category" label="Category" sortable>{{props.row.category}}</b-table-column>
        <b-table-column class="centered-table-content" field="action" label="">
          <button @click="editQuestion(props.row.challengeId)" style="margin-left: 5px;" class="button is-outlined">
            Edit
          </button>
        </b-table-column>
        <b-table-column class="centered-table-content" field="action" label="">
          <button @click="confirmDeleteQuestion(props.row.challengeId)" style="margin-left: 5px;" class="button is-danger is-outlined">
            Delete
          </button>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
  import { DialogProgrammatic as Dialog } from 'buefy'
  import questionService from '../../services/questionsService'
  import { DeleteError } from '../../errors/DeleteError'

  import textutils from '../../helpers/text-helper'
  import displayHelper from '../../helpers/display-helper'

  export default {
    name: 'question-table',
    created () {
      this.loadQuestionList()
    },
    data () {
      return {
        isLoading: true,
        deleteError: null,
        questions: null,
        txtFilter: '',
        columns: [
          {
            field: 'name',
            label: 'Question Name',
          },
          {
            field: 'question',
            label: 'Question',
          },
          {
            field: 'points',
            label: 'Points',
          },
          {
            field: 'difficulty',
            label: 'Difficulty',
          },
          {
            field: 'category',
            label: 'Category',
          },
        ],
        searchFilter: this.$route.params.txtFilter,
      }
    },
    filters: {
      truncate(value, length) {
        return textutils.truncate(value, length)
      },
    },
    methods: {
      getRowClass(row, index) {
        if (this.searchFilter && this.searchFilter !== '') {
          let found = false
          let searchLower = this.searchFilter.toLowerCase()
          for (let col of this.columns) {
            if (row[col.field] && row[col.field].toString().toLowerCase().indexOf(searchLower) >= 0) {
              found = true
            }
          }
          if (found === false) {
            return 'is-hidden'
          }
        }
        if (this.isHideSelected) {
          if (this.checkedRows.includes(row)) {
            return 'is-hidden'
          }
        } else {
          return 'is-info'
        }
      },
      loadQuestionList () {
        var parent = this
        questionService.getQuestions()
          .then((questions) => {
            this.questions = questions
          },
            (err) => {
              this.isError = true
              displayHelper.displayError(parent,  'Oops, the challenges could not be listed: ' + err.message)
            })
          .finally(() => {
            this.isLoading = false
          })
      },
      editQuestion(challengeId) {
        this.$router.push({ name: 'EditQuestionForm', params: { id: challengeId, txtFilter: this.searchFilter } })
      },
      deleteQuestion(challengeId) {
        var parent = this
        this.isLoading = true
        this.isError = false
        this.isDeleteError = false
        questionService.deleteQuestion(challengeId)
          .then(() => {
            displayHelper.displaySuccess(parent,  'Challenge successfully deleted')
          })
          .catch((err) => {
            console.log('Error Message', err.message)
            if (err instanceof DeleteError) {
              displayHelper.displayError(parent,  'This challenge could not be deleted because at least one game' +
                      ' currently active is associated to it: ' + err.names.join(', '))
            } else {
              this.isError = true
              displayHelper.displayError(parent,  'Error while deleting the challenge: ' + err.message)
            }
          })
          .finally(() => {
            this.loadQuestionList()
          })
      },
      confirmDeleteQuestion (challengeId) {
        Dialog.confirm({
          message: 'Warning! This will delete the challenge from all games it is associated with. Are you sure you want to proceed?',
          onConfirm: () => this.deleteQuestion(challengeId)
        })
      }
    }
  }
</script>
